// extracted by mini-css-extract-plugin
export var button = "_31-1";
export var featuredLink = "_31-4";
export var spinner = "_31-2";
export var spinnerContainer = "_31-3";
export var text = "_31-0";